import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaFacebookF } from 'react-icons/fa';
import { AiOutlineGoogle } from 'react-icons/ai';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import Collapsible from 'react-collapsible';
 
const Sidebar = ({ show, handleClose }) => { 
   return (
      <>

         <div className='side__bar'>
            <Offcanvas show={show} onHide={handleClose} placement='end'>
               <Offcanvas.Header closeButton>
                  {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
               </Offcanvas.Header>
               <Offcanvas.Body>


                  <Collapsible trigger={<NavLink to="/home">Accueil</NavLink> } triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}> 
                  </Collapsible> 

                  <Collapsible trigger={<NavLink to="/services">Services </NavLink>} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}> 
                  </Collapsible>

                  <Collapsible trigger={<NavLink to="/projects">Projects</NavLink>} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}> 
                  </Collapsible>


                  <Collapsible trigger={<NavLink to="/contact">Contact</NavLink>} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}> 
                     <ul className="sidebar_sub_menu text-white mt-3">
                        <li><NavLink to="/contact">Contact</NavLink></li>
                        <li><NavLink to="/about">A propos</NavLink></li>
                        <li><NavLink to="/faq">Faq</NavLink></li>
                     </ul>
                  </Collapsible> 

                  <div className="fix">
                     <div className="side-info">
                        <div className="side-info-content">
                           <div className="tp-mobile-menu"></div>
                           <div className="contact-infos mb-30">
                              <div className="contact-list mb-30">
                                 <h4>Informations de contact</h4>
                                 <ul>
                                    <li><i className="flaticon-pin"></i>YATCHIKA GSB CHANTEVA, Douala Cameroun</li>
                                    <li><i className="flaticon-email"></i><a href="mailto:contact@hg-services.com">contact@hg-services.com</a></li>
                                    <li><i className="flaticon-phone-call"></i><a href="tel:+237687788330">687 78 83 30</a></li>
                                 </ul>
                                 <div className="sidebar__menu--social">
                                    <a className="text-white" href="/"><i><FaFacebookF className='icon' /> </i></a>
                                    <a className="text-white" href="/"><i><BsTwitter className='icon' /> </i></a>
                                    <a className="text-white" href="/"><i><BsInstagram className='icon' /> </i></a>
                                    <a className="text-white" href="/"><i><AiOutlineGoogle className='icon' /> </i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </Offcanvas.Body>
            </Offcanvas>
         </div>
      </>
   );
};

export default Sidebar;